<script setup lang="ts">
import InnerNav from '@/components/dashboard/InnerNav.vue'
import type { InnerNavItem } from '@/types/all'
import { ref, watch, computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const innerNavItems: InnerNavItem[] = [
  { label: 'Home', route: 'dashboard-home', active: true },
  { label: 'Flights', route: 'dashboard-flights', active: false },
  { label: 'Invoices & Credits', route: 'dashboard-invoices', active: false },
  { label: 'Travelers', route: 'dashboard-travelers', active: false },
  { label: 'Insights', route: 'dashboard-insights', active: false },
]

// Initialize active tab based on current route name
const getCurrentTabIndex = () => {
  const currentRouteName = route.name as string
  return innerNavItems.findIndex((item) => item.route === currentRouteName)
}

const activeInnerTab = ref(getCurrentTabIndex())
const pageTitle = computed(() => innerNavItems[activeInnerTab.value]?.label || 'Dashboard')

// Listen for route changes to update the active tab
// Fixes issue where the active tab is not updated when navigating directly to a route or refreshing
watch(
  () => route.name,
  (newRouteName) => {
    const tabIndex = innerNavItems.findIndex((item) => item.route === newRouteName)
    if (tabIndex !== -1 && tabIndex !== activeInnerTab.value) {
      activeInnerTab.value = tabIndex
    }
  },
  { immediate: true },
)

// Example data
</script>

<template>
  <div>
    <!-- Inner Navigation -->
    <InnerNav :inner-nav-items="innerNavItems" v-model:activeInnerTab="activeInnerTab"> </InnerNav>
    <!-- Page Header -->

    <!-- Page Content -->
    <div class="space-y-6 mb-16">
      <!-- Placeholder for Content Panels -->
      <RouterView :page-title="pageTitle" />
    </div>
  </div>
</template>
